module.exports = __webpack_public_path__ + "static/media/upload.2bbc1df5.png";


//////////////////
// WEBPACK FOOTER
// ./src/Assets/upload.png
// module id = 7541
// module chunks = 0